import { enUS, ja, zhCN, zhTW, ko, it } from 'date-fns/locale';
import i18n from '../i18n';
import type { Locale } from 'date-fns';

const localeMap: Record<string, Locale> = {
  en: enUS,
  ja,
  'zh-CN': zhCN,
  'zh-TW': zhTW,
  ko,
  it,
};

export function getDateLocale(): Locale {
  return localeMap[i18n.language] || enUS;
}
